





































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import Tools from '../../../../../lib/tools';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'specialTypeOfWork',
	components: {
		QuickTable
	}
})
export default class SpecialTypeOfWork extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		organizations: [],			// 部门数据
		sexData: [],
		formData: {
			id: '',
			personName: '',
			sex: 0,
			birthday: '',
			workYears: null,
			belongDepId: '',
			place: '',
			placeWorkYears: null,
			trainDt: '',
			reviewDt: '',
			certificationDep: '',
			certificationNo: '',
			idCardNo: null
		},
		validate: {
			personName: [
				{ required: true, message: '请填写姓名', trigger: 'blur' }
			],
			belongDepId: [
				{ required: true, type: 'number', message: '请选择所属部门', trigger: 'change' }
			],
			idCardNo: [
				{ required: true, message: '请填写身份证号码', trigger: 'blur' },
				{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请填写正确的身份证号码', trigger: 'blur' }
			],
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '姓名',
				key: 'personName',
				width: 96
			},
			{
				title: '性别',
				key: 'sexDesc',
				width: 68
			},
			{
				title: '出生年月',
				key: 'birthday',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.birthday));
				}
			},
			{
				title: '工作年限',
				key: 'workYears',
				width: 86
			},
			{
				title: '所属部门',
				key: 'belongDep',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', params.row.belongDep ? params.row.belongDep.displayName : '');
				}
			},
			{
				title: '现任岗位',
				key: 'place',
				width: 128
			},
			{
				title: '从事本岗位年限',
				key: 'placeWorkYears',
				width: 128
			},
			{
				title: '培训时间',
				key: 'trainDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.trainDt));
				}
			},
			{
				title: '复审时间',
				key: 'reviewDt',
				width: 106,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.reviewDt));
				}
			},
			{
				title: '发证单位',
				key: 'certificationDep',
				minWidth: 140
			},
			{
				title: '操作证号码',
				key: 'certificationNo',
				minWidth: 160
			},
			{
				title: '身份证号码',
				key: 'idCardNo',
				width: 160
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = params.row[k];
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 查询数据字典
    	this.$store.dispatch('project/GetAllDictionary').then(() => {
    		// 性别
    		this.initData.sexData = this.$store.state.project.allDictionary[7].items.map((item:any) => {
    			return {
    				label: item.displayName,
    				value: item.id
    			}
    		});
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						if(k == 'birthday' || k == 'trainDt' || k == 'reviewDt') {
							params[k] = Tools.formatDate(datas[k]);
						}else{
							params[k] = datas[k];
						}
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/SafetyProduct/UpdateSpecialTypeOfWorkAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyProduct/CreateSpecialTypeOfWorkAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此特殊工种管理台账？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteSpecialTypeOfWorkAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
